export const observerConfig = {
  threshold: 0.2,
  rootMargin: "500px",
};
